import { Typography } from '@lamimed/pantheon';
import Image from 'next/legacy/image';
import Carousel, { ScrollMode } from 'nuka-carousel';

import { useCategory } from 'hooks/useCategory';

import { Step } from '../Step';

import * as S from './styles';

export const StepsCarousel: React.FC = () => {
  const { categoryData } = useCategory();

  const stepsCount = categoryData?.howItWorks.length || 0;

  return (
    <S.Wrapper>
      <Carousel
        renderCenterLeftControls={null}
        renderBottomCenterControls={null}
        renderCenterRightControls={null}
        scrollMode={ScrollMode.remainder}
        slidesToShow={stepsCount > 4 ? 4.3 : stepsCount}
        slidesToScroll={3}
        dragThreshold={0.1}
        renderBottomLeftControls={({ previousSlide, currentSlide }) => {
          if (currentSlide !== 0) {
            return (
              <S.LeftSlideControl
                aria-label="previous slide"
                onClick={previousSlide}
              >
                <S.PreviousArrow
                  src="/images/assets/slider-arrow.svg"
                  width={45}
                  height={12}
                />

                <Typography color="text__secondary">Indietro</Typography>
              </S.LeftSlideControl>
            );
          }
        }}
        renderBottomRightControls={({
          nextSlide,
          currentSlide,
          slidesToShow,
          slideCount,
        }) => {
          const shouldShowNextButton = currentSlide < slideCount - slidesToShow;

          if (shouldShowNextButton) {
            return (
              <S.SlideControl aria-label="next slide" onClick={nextSlide}>
                <Typography color="text__secondary">Avanti</Typography>

                <Image
                  src="/images/assets/slider-arrow.svg"
                  width={45}
                  height={12}
                />
              </S.SlideControl>
            );
          }
        }}
      >
        {categoryData?.howItWorks.map((step, index, { length }) => (
          <Step
            key={step.title}
            title={step.title}
            description={step.description}
            stepNumber={index + 1}
            isLast={length - 1 === index}
          />
        ))}
      </Carousel>
    </S.Wrapper>
  );
};
